import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { MembershipService } from '../services/membership.service';
import { TokenModel } from 'app/models/token.model';

@Injectable()
export class WorkflowGuard implements CanActivate {
  constructor(private router: Router, private membership_service: MembershipService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return from(this.membership_service.GetToken())
      .pipe(
        map((token: TokenModel) => {
          if (token && token.current_property && token.current_property.workflow_admin) {
            return true;
          }
          this.router.navigate(['dashboard']);
          return false;
        }),
        catchError(() => {
          this.router.navigate(['dashboard']);
          return of(false);
        })
      );
  }
}
